import React from "react";
import { MarsImageSelector } from "./mars/ImageSelector.mars";
import { JunoImageSelector } from "./juno/ImageSelector.juno";

export const ImageSelector = () => {
  if (CONFIG.title === "MeteoJuno") {
    return <JunoImageSelector></JunoImageSelector>;
  }
  return <MarsImageSelector></MarsImageSelector>;
};
